import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";
import { toMoney } from "../../util/Utils";
import { Box, TextField } from "@mui/material";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function OrderDeliveryDetails(props) {
  const { isSmall } = useBreakpoints();

  return (
    <Dialog
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      maxWidth="md"
      open={props.openDialoge.show}
      onClose={() =>
        props.setOpenDialoge({ ...props.openDialoge, show: false })
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle color="secondary" id="alert-dialog-title">
        جزئیات گزارش ارسال سفارشات {props.openDialoge.model?.dayname}
      </DialogTitle>
      <DialogContent>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="تعداد سفارشات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.totalOrder
                  ? toMoney(props.openDialoge.model?.totalOrder)
                  : "0"
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="ارسال پیک"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.peikOrder
                  ? toMoney(props.openDialoge.model?.peikOrder)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="پیک عادی"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.normalPeik
                  ? toMoney(props.openDialoge.model?.normalPeik)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="پیک اکسپرس"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.expressPeik
                  ? toMoney(props.openDialoge.model?.expressPeik)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="ارسال پست"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.postOrder
                  ? toMoney(props.openDialoge.model?.postOrder)
                  : 0
              }
              variant="filled"
            />
          </Box>

          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            {/* <Box sx={{ display: "flex", alignItems: "center" }}>
              <FiberManualRecordIcon color="secondary" fontSize="small" />
              <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
                پارت 1
              </Typography>
            </Box> */}

            <TextField
              fullWidth
              id="outlined-basic"
              label=" ارسال پیک ( پارت 1 )"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.part1?.peikOrder
                  ? toMoney(props.openDialoge.model?.part1?.peikOrder)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            {/* <Box sx={{ display: "flex", alignItems: "center" }}>
              <FiberManualRecordIcon color="secondary" fontSize="small" />
              <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
                پارت 2
              </Typography>
            </Box> */}

            <TextField
              fullWidth
              id="outlined-basic"
              label=" ارسال پیک ( پارت 2 )"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.part2?.peikOrder
                  ? toMoney(props.openDialoge.model?.part2?.peikOrder)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            {/* <Box sx={{ display: "flex", alignItems: "center" }}>
              <FiberManualRecordIcon color="secondary" fontSize="small" />
              <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
                پارت 3
              </Typography>
            </Box> */}

            <TextField
              fullWidth
              id="outlined-basic"
              label=" ارسال پیک ( پارت 3 )"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.part3?.peikOrder
                  ? toMoney(props.openDialoge.model?.part3?.peikOrder)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مبلغ دریافت شده اکسپرس"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.expressReciveCost
                  ? toMoney(props.openDialoge.model?.expressReciveCost)
                  : 0
              }
              variant="filled"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مبلغ پرداخت شده اکسپرس"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={
                props.openDialoge.model?.expressPayCost
                  ? toMoney(props.openDialoge.model?.expressPayCost)
                  : 0
              }
              variant="filled"
            />
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            gridColumn="span 12"
          >
            <Button
              onClick={() =>
                props.setOpenDialoge({ ...props.openDialoge, show: false })
              }
              color="secondary"
              variant="contained"
            >
              بستن
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
